import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

/**
 * Tilt3D — gives a child element a subtle 3D tilt that follows the cursor.
 * Disabled on touch devices.
 */
const Tilt3D = ({ children, max = 8, scale = 1.02, className = "", ...rest }) => {
  const ref = useRef(null);
  const rx = useMotionValue(0);
  const ry = useMotionValue(0);
  const srx = useSpring(rx, { stiffness: 200, damping: 18 });
  const sry = useSpring(ry, { stiffness: 200, damping: 18 });

  const onMove = (e) => {
    if (!ref.current) return;
    if (!window.matchMedia("(pointer: fine)").matches) return;
    const r = ref.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width; // 0..1
    const py = (e.clientY - r.top) / r.height; // 0..1
    ry.set((px - 0.5) * 2 * max); // rotateY (left/right)
    rx.set(-(py - 0.5) * 2 * max); // rotateX (up/down)
  };
  const onLeave = () => {
    rx.set(0);
    ry.set(0);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={{
        rotateX: srx,
        rotateY: sry,
        transformPerspective: 1000,
      }}
      whileHover={{ scale }}
      transition={{ scale: { duration: 0.25, ease: "easeOut" } }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default Tilt3D;
